import React, { useContext, useEffect, useState } from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DownloadIcon from "@mui/icons-material/GetApp";
import Divider from '@mui/material/Divider';
import config from '../../hoa-config';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import { LinearProgress, Button, Modal, Container, Stack, Box, Skeleton, Autocomplete, TextField } from '@mui/material';
import dashboardServices from "../../services/hoa-dashboard-api-service";
import { GlobalContext } from "../../context/hoa-global-context";
import datastore from "../../store/hoa-datastore";
import EmailViewContainer from "../emails/hoa-email-view-container";
import TryagainModal from "../Tryagain-modal/TryagainModal";
import { saveNewLogsInDatastore } from "../../utility/change-log";
import LoadingComponent from "../loading-component/loading-component";
import EmailNonAssignableComponent from "../emails/hoa-email-non-assignable-component";
import UpdatePropertyAvailableComponent from "../emails/hoa-email-update-property-comp";
import useCreateLogs from '../../hooks/useCreateLogs';
import propertyTaskService from "../../services/hoa-property-task-service";
import EditCancelConfirmationModal from "../../shared-components/edit-cancel-confirmation";

export default function EmailAssignDocument(props: any) {
    const { 
        view, 
        setView, 
        tagType,
        toggleModalOpen, 
        selectedValues, 
        updateSelectedValues, 
        assignedPropertyList, 
        setAssignedPropertyList, 
        currentAssignedProperty, 
        setCurrentAssignedProperty, 
        deletedAssignedPropertyList, 
        setDeletedAssignedPropertyList 
    } = props;

    const {email, updateEmailData} = useContext<any>(GlobalContext);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState(selectedValues)
    const [open, setOpen] = useState(false);
    const [url, setUrl] = useState('');
    const [documents, setDocuments] = useState([]);
    const temp : any = JSON.parse(JSON.stringify(selectedValues))
    const [loadingBody, setLoadingBody] = useState(false);
    const [isCancelClicked, setIsCancelClicked] = useState(false);
    const [cachedSendFrom, setCachedSendFrom] = useState('N/A');
    const [cachedSubject, setCachedSubject] = useState('N/A');

    useEffect(() => {
    const validSendFrom = Array.isArray(selectedValues.sendFrom) && selectedValues.sendFrom.length > 0;
    const validSubject = typeof selectedValues.subject === 'string' && selectedValues.subject.trim() !== '';

    if (selectedValues.sourceType === 'Email') {
      setCachedSendFrom(validSendFrom ? selectedValues.sendFrom.join(', ') : 'N/A');
      setCachedSubject(validSubject ? selectedValues.subject : 'N/A');
    } else {
      if (cachedSendFrom === 'N/A' && validSendFrom) {
        setCachedSendFrom(selectedValues.sendFrom.join(', '));
      }

      if (cachedSubject === 'N/A' && validSubject) {
        setCachedSubject(selectedValues.subject);
      }
    }
  }, [selectedValues, selectedValues.sourceType]);

    const handleClose = () => {
        setOpen(false);
    }

    useEffect(() => {
        setState({...state, propertyList: assignedPropertyList})
    },[assignedPropertyList]);

    useEffect(() => {
        if(selectedValues?.propertyList){
            setAssignedPropertyList(selectedValues.propertyList)
        }
        return() => {
            setAssignedPropertyList([]);
            setDeletedAssignedPropertyList([]);
        }
    },[]);

    const isNonAssignableValueChange = () => {
        return state.emailNonAssignable !== selectedValues.emailNonAssignable
    }

    const isPropertyUpdateAvailableChange = () => {
        return selectedValues.propertyUpdateAvailable !== state.propertyUpdateAvailable
    }

    const onSaveClick = async () => {
        if((state.emailType && currentAssignedProperty) || deletedAssignedPropertyList.length > 0 || isNonAssignableValueChange() || isPropertyUpdateAvailableChange()){
            if(state?.emailNonAssignable === true && !state.nonAssignedEmailOrg) {
                return window.alert('Please add organization')
            }
            setOpen(!open);
        }else{
            return;
        }
        
    }

    const onCancelYesClick = async () => {
        setDeletedAssignedPropertyList([]);
        setCurrentAssignedProperty(null);
        updateSelectedValues(temp);
        setView("list");
        setIsCancelClicked(false);
    }

    const onCancelClick = () => {
        setIsCancelClicked(!isCancelClicked)
    }

    const handleChange = (value: any) => {
        setState({...state, emailType: value})
    }

    const removeCurrentAssignedProperty = async() => {
        setCurrentAssignedProperty(null);
    }

    const removePropertyFromPropertyList = (removedProperty: any) => {
        if (removedProperty?.objectId) {
            // remove from propertyList
            
            const copyOfAssignedPropertyList = JSON.parse(JSON.stringify(assignedPropertyList));
            let  indexOfRemovedProperty = -1;
            
            copyOfAssignedPropertyList.forEach((property:any, index: number) => {
                if (property?.objectId === removedProperty.objectId) {
                    indexOfRemovedProperty = index;
                }
            });

            if (indexOfRemovedProperty > -1) {
                copyOfAssignedPropertyList.splice(indexOfRemovedProperty, 1);            
            }

            setAssignedPropertyList(copyOfAssignedPropertyList);

            // add removed item in deletedPropertyList

            setDeletedAssignedPropertyList([...deletedAssignedPropertyList, removedProperty]);   
        }
    }

    const renderAssignedPropertyList = () => {
        return assignedPropertyList.map((assignedProperty:any) => {
            return (
                <div className="assigned-property-container">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                        <div className="text-303030-16px normal">External Id: {assignedProperty?.hoaPropertyDetails?.externalId}</div>
                        <Button style={{ background: "#787878" }} onClick={() => removePropertyFromPropertyList(assignedProperty)}>
                            <DeleteOutline id='icon-componenet' />
                        </Button>
                    </div>
                    <div style={{ color: "#3576E5", fontSize: 16, fontWeight: 400, marginBottom: 34, boxShadow: "inset 0px -1px 0px #E8E8E8" }}>
                        <div style={{ marginBottom: 24 }}>{assignedProperty?.fullAddress}</div>
                    </div>
                </div>
            )
        });
    }

    const downloadAttachment = async (fileName: string) => {
        if(selectedValues.objectId){
            let path = `${'hoaEmails'}/${fileName}`;
            let bucketName = 'hoa-dashboard';
            const signedUrl = await dashboardServices.getSignedUrl(path, bucketName);
            window.open(signedUrl.data, "_blank");
        }
    }

    const loadEmailBody = async () => {
        setLoadingBody(true);
        if(Array.isArray(selectedValues.attachmentDetails) && selectedValues.attachmentDetails.length > 0){
            let file = selectedValues.attachmentDetails.find((file: any) => file?.split('.')[1] === 'txt');
    
            let path = `${'hoaEmails'}/${file}`;
            const documentUrl = await dashboardServices.getSignedUrl(path, 'hoa-dashboard', false, true);
            if(file && documentUrl){
                setUrl(documentUrl.data)
            }
        }
        setLoadingBody(false);
    }


    const isEmailSaveButtonDisabled = () => {
        return !(
            state.emailType && (currentAssignedProperty || 
            deletedAssignedPropertyList.length > 0 || 
            isNonAssignableValueChange())
        )
    };

    useEffect(() => {
        loadEmailBody();
    },[selectedValues])

    useEffect(() => {
        if(Array.isArray(selectedValues.attachmentDetails)){
            let files = selectedValues.attachmentDetails.filter((file: any) => {
                if(file?.split('.')[1] != 'txt') return file;
            })
            setDocuments(files)
        }
    }, [selectedValues])

    return (
        <div style={{ justifyContent: 'center', fontSize: '20px', width: "100%", height: "100%", boxSizing: "border-box" }}>
            <div style={{ display: 'flex', flexDirection: 'column', borderRadius: "4px", width: "100%" }}>
                <div style={{ borderBottom: "1px solid #E8E8E8", display: "flex", flexDirection: "row", justifyContent: "space-between", padding: "0 24px", alignItems:'center', height:'102px' }}>
                    <div style={{ display:'flex'}}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            {
                                props.view === "update" ?
                                    <span className="titleText">Assign Email</span>
                                    : 
                                    <div style={{ display:'flex'}}>
                                        <span className="titleText">Email Details</span>
                                    </div>
                            }
                            {
                                props.view === "update" ?
                                    <span className="helperText">Sent on {state.emailServerTime}</span>
                                    :
                                    <span className="helperText">Last Updated on {state.updatedAt}</span>
                            }
                        </div>
                    </div>
                    {
                        props.view !== 'view' &&
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <Button variant="outlined" color="primary" style={{ height: "40px", padding: "5px 25px", marginRight: "5px" }}
                                onClick={isEmailSaveButtonDisabled() ? onCancelYesClick : onCancelClick}>Cancel</Button>
                            <Button disabled={isEmailSaveButtonDisabled()} variant="contained" color="primary" style={{ height: "40px", padding: "5px 25px" }} onClick={onSaveClick}>
                                {loading ? "Saving..." : "Save"}
                            </Button>
                        </div>
                    }
                    {
                        props.view === 'view' &&
                        <div style={{ display: "flex", flexDirection: "row" }}>
                                {
                                    datastore.isUserPermitted('Municipality', 'update') &&
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<EditIcon />}
                                        style={{ height: "40px", padding: "5px 25px", marginRight: "5px" }}
                                        onClick={() => {
                                            props.setView("update")
                                        }}>
                                        Edit
                                    </Button>
                                }
                        </div>
                    }
                </div>
                <LoadingComponent loading={loading} />
            {
                view === 'view' ?
                <EmailViewContainer 
                    view={view}
                    selectedValues={selectedValues}
                />
                :
                <div className="mail-assign-container">
                    <div className="mail-assign-pdf-container" style={{overflow: 'scroll'}}>
                        <div className="sub-title-text">{cachedSubject}</div>
                             <span className="helperText">From {cachedSendFrom}</span>
                        <div 
                            className="text-303030-16px normal" 
                            style={{marginTop: '24px', height: '450px', paddingBottom: '24px', borderBottom: '1px solid #E8E8E8'}}>
                            {
                                !url && loadingBody ?
                                <Box>
                                        <Skeleton animation="wave" />
                                        <Skeleton animation="wave" />
                                        <Skeleton animation="wave" />
                                        <Skeleton animation="wave" />
                                        <Skeleton animation="wave" />
                                </Box>
                                : !url && !loadingBody ? <p>There is no Email body!!!</p>
                                :
                                <object data={url} type="text/*" style={{ width: "100%", height: '450px'}}>
                                    <div className='m-3'>
                                        <p>
                                            Your browser does not support viewing this file.
                                            You can <a href={url} target="_blank">click here to download the file</a >.
                                        </p> 
                                    </div>
                                </object>
                            }
                        </div>
                        <div style={{marginTop: '24px'}}>
                            <div className="sub-title-text">Documents</div>
                            {
                               documents.map(((file: any) => (
                                <div style={{ cursor: "pointer" }} className="ov-pdf-container" onClick={()=> downloadAttachment(file)}>
                                    <Stack direction={"row"} alignItems={"center"}>
                                        <PictureAsPdfIcon style={{ width: "20px", height: "20px" }} />
                                        <span style={{ marginLeft: "14px" }} className="text-3E3E3E-14px normal">{file?.split('-')?.pop()}</span>
                                    </Stack>
                                    <DownloadIcon style={{ width: "20px", height: "20px", color: "#3576E5" }} />
                                </div>
                                )))
                            }
                        </div>
                    </div>
                    <div className="mail-assign-property-container" style={{overflowY: 'scroll', width: '56%'}}>
                        <div className="sub-title-text" style={{marginBottom:"24px"}}>Basic Information</div>
                        <Autocomplete
                            ListboxProps={{ style: { maxHeight: "200px"} }}
                            style={{ width: "80%", height:"62px", boxSizing:"border-box"}}
                            disablePortal
                            value={state.emailType ? state.emailType : ''}
                            options={config.assignMailDocumentTypes}
                            onChange={(e, v) => {
                                handleChange(v)
                            }}
                            renderInput={(params: any) => <TextField variant="standard" required style={{height:"100%"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label="Email Type"/>}
                        />
                        {
                            assignedPropertyList.length == 0 ? 
                            <>
                                <div className="sub-title-text" style={{ marginTop:"24px" }}>Assign to a Property</div>
                                <div className="helperText" style={{ marginBottom: "10px" }}>Please select the property to assign the document</div>
                            </>
                            :  <div className="sub-title-text" style={{ marginTop:"24px" }}>Assigned Property List</div>
                        }
                        {
                            assignedPropertyList.length == 0 ?
                            <Button 
                                variant="contained"
                                color="primary"
                                disabled={state.status === 'Non-assignable' || state.emailNonAssignable === true}
                                onClick={()=> toggleModalOpen(true)}
                            >
                                Assign Property *
                            </Button>
                            :
                            <Button 
                                variant="contained"
                                color="primary"
                                onClick={()=> toggleModalOpen(true)}
                            >
                                Assign More Property
                            </Button>                        
                        }
                        <EmailNonAssignableComponent 
                            state={state}
                            setState={setState}
                            isPropertyListChange={currentAssignedProperty || deletedAssignedPropertyList.length > 0}
                        />
                        <UpdatePropertyAvailableComponent 
                            state={state}
                            setState={setState}
                        />
                        {
                            currentAssignedProperty ?
                            <>
                                <div className="assigned-property-container">
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                        <div className="text-303030-16px normal">External Id: {currentAssignedProperty?.hoaPropertyDetails?.externalId}</div>
                                        <Button style={{ background: "#787878" }} onClick={removeCurrentAssignedProperty}>
                                            <DeleteOutline id='icon-componenet' />
                                        </Button>
                                    </div>
                                    <div style={{ color: "#3576E5", fontSize: 16, fontWeight: 400, marginBottom: 34, boxShadow: "inset 0px -1px 0px #E8E8E8" }}>
                                        <div style={{ marginBottom: 24 }}>{currentAssignedProperty?.fullAddress}</div>
                                    </div>
                                </div>
                                <Divider/>
                            </>
                            : <> </>
                        }
                        {
                            renderAssignedPropertyList()
                        }
                    </div>
                </div>
            }
            <SaveComponent 
                currentAssignedProperty={currentAssignedProperty} 
                setCurrentAssignedProperty={setCurrentAssignedProperty} 
                deletedAssignedPropertyList={deletedAssignedPropertyList} 
                email={email} 
                updateEmailData={updateEmailData} 
                tagType={tagType}
                open={open} 
                setOpen={setOpen} 
                handleClose={handleClose} 
                state={state} 
                view={view} 
                setView={setView} 
                setLoading={setLoading}
                isNonAssignableValueChange={isNonAssignableValueChange}
                selectedValues={selectedValues}
            />

            <EditCancelConfirmationModal 
                isCancelClicked={isCancelClicked}
                setIsCancelClicked={setIsCancelClicked}
                onCancelYesClick={onCancelYesClick}
            />
		</div>
        </div>
	);
}

const SaveComponent = ({currentAssignedProperty , setCurrentAssignedProperty, deletedAssignedPropertyList, email,updateEmailData, open, setOpen, handleClose, state, view, setView, setLoading, isNonAssignableValueChange, selectedValues, tagType}: any) => {
    const {pendingSource, updatePendingSource} = useContext<any>(GlobalContext);
    const[showApiErrorModal,setShowApiErrorModal] = useState(false)
    const { createLogsForNonAssignableEmail, revertNonAssignableEmailLog } = useCreateLogs();
    const currentUser = datastore.ownerInformation.email

    const propertyAssignToEmail = async () => {
        const copyOfState = JSON.parse(JSON.stringify(state));
        copyOfState.lastUpdatedBy = datastore.ownerInformation.email;
        if(currentAssignedProperty) {
            copyOfState.propertyList.push(currentAssignedProperty);
        }

        const updatedResult = await dashboardServices.propertyAssignToEmail(copyOfState);

        if (tagType === 'PendingSource') {
            // find the index of the updated email in the pendingSource.data array and remove it from pendingSource.data array
            const copyPendingSourceState = JSON.parse(JSON.stringify(pendingSource));
            copyPendingSourceState.data.filter((value: any, index: number) => {
                if(value.objectId === state.objectId){
                    copyPendingSourceState.data.splice(index, 1);
                }
            })
            updatePendingSource(copyPendingSourceState)
        } else {
            let updateIndex = 0;
            email.data.find((value: any, index: number) => {
                if(value.objectId === state.objectId){
                    updateIndex = index;
                }
            });
    
            email.data[updateIndex] = updatedResult.data;
            updateEmailData({...email})
        }

        return updatedResult;
    }
    const createLogsPayloadMaker = (propertyId:string, status: string, billableItem?: string) => {
        const type = 'Property';

		// set primaryEvent
		var events:any = [];
		var primaryEvent = "";

		if(type == 'Property') {
			primaryEvent = `${config.changeLongActionsProperty[status]} (${state?.objectId})`;
		}

        events.push(primaryEvent);
        let logMessage={}
		if(events.length > 0) {
			 logMessage = {
				events:events,
				billItem: billableItem ? billableItem : '',
				evidenceLink: '',
				user: datastore.ownerInformation.name,
				prevState:{},
				updatedState:{},
				type:type,
				tagTypeId:propertyId
			}
        }
        return logMessage
    }
    const createMultipleLogs =async(payload:any)=>{
         const result = await dashboardServices.createMultipleLogs(payload);
         saveNewLogsInDatastore(result.data, datastore);
    }
    const createOrUpdatePropertyAssignLog = async (apiResponse:any) => {
        const billableItem = "Email Processing";
        const createLogArgs=[]
        if (currentAssignedProperty) {
            // create new Email Processing log
            createLogArgs.push(createLogsPayloadMaker(currentAssignedProperty?.objectId, 'assignedToEmail', billableItem))
        }

        if (Array.isArray(deletedAssignedPropertyList) && deletedAssignedPropertyList.length > 0) {
            for (let property of deletedAssignedPropertyList) {
                createLogArgs.push(createLogsPayloadMaker(property?.objectId, 'unAssignedToEmail', 'Not Billable'));

                //update previous log
                await dashboardServices.updateMailOrEmailAssignedLog(property?.objectId, 'email', apiResponse?.data?.objectId, 0, 'Not Billable');
            }
        }
        
        await createMultipleLogs(createLogArgs);
    }

    const createEmailLog = async (apiResponse:any) => {
        let logsData = {
            action: 'Assigned',
            updatedBy: datastore.ownerInformation.email,
            email: apiResponse.data,
            emailId: apiResponse.data?.objectId
        }

        await dashboardServices.createMailLog(logsData);
    }

    const isPropertyListChange = () => {
        return currentAssignedProperty || deletedAssignedPropertyList.length > 0
    }

    const isPropertyUpdateAvailableChange = () => {
        return selectedValues.propertyUpdateAvailable !== state.propertyUpdateAvailable
    }

    const propertyTaskCreationAndDelectation = async () => {

        if(isPropertyUpdateAvailableChange() && state.propertyUpdateAvailable === false) {
            if (deletedAssignedPropertyList.length > 0) {
                await propertyTaskService.deletePropertyTask({
                    propertyList: [...deletedAssignedPropertyList, ...state.propertyList],
                    emailId: state.objectId,
                    taskSourceType: "email",
                });
            } else {
                await propertyTaskService.deletePropertyTask({
                    propertyList: state.propertyList,
                    emailId: state.objectId,
                    taskSourceType: "email",
                });
            }
            return;
        }

        if(isPropertyListChange() && state.propertyUpdateAvailable === true) {
            if (currentAssignedProperty) {
				//? need to add a task
				await propertyTaskService.createPropertyTask({
					propertyId: currentAssignedProperty.objectId,
					propertyAssignedDate: new Date(),
					emailId: state.objectId,
					taskSourceType: "email",
				});
			}
			if (deletedAssignedPropertyList.length > 0) {
				//? need to delete a task
				await propertyTaskService.deletePropertyTask({
					propertyList: deletedAssignedPropertyList,
					emailId: state.objectId,
					taskSourceType: "email",
				});
			}
        }
    }

    const onSaveClick = async () => {
        try{

            setLoading(true);
            setShowApiErrorModal(false)
            handleClose();

            if(isPropertyUpdateAvailableChange()) {
                const result = await dashboardServices.updatePropertyAvailableCheck({
                    emailId:state.objectId,
                    propertyUpdateAvailable:state.propertyUpdateAvailable
                })

                const selectedIndex = email.data.findIndex((value: any, index: number) => value.objectId === state.objectId);
                email.data[selectedIndex] = result.data;
                updateEmailData({...email})
            }
            
            propertyTaskCreationAndDelectation();
            if(isPropertyListChange()) {
                console.log("Assigned Property list")
                const res = await propertyAssignToEmail();
                await createEmailLog(res);
                await createOrUpdatePropertyAssignLog(res);
            }
            else if(isNonAssignableValueChange()) {
                if(state.status === 'Unassigned' && state.emailNonAssignable === true) {
                    console.log("Non Assignable 1")
                    const result = await dashboardServices.updateMailToNonAssignable(state.objectId, state.emailType, currentUser, 'email', state.nonAssignedEmailOrg);
                    await createLogsForNonAssignableEmail(state.objectId, state.nonAssignedEmailOrg);

                    const selectedIndex = email.data.findIndex((value: any, index: number) => value.objectId === state.objectId);
                    email.data[selectedIndex] = result.data;
                    updateEmailData({...email})

                } else if(state.status === 'Non-assignable' && state.emailNonAssignable === false) {
                    console.log("Non Assignable 2")
                    const result = await dashboardServices.updateMailToNonAssignableUnChecked(state.objectId, state.emailType, currentUser, 'email', state.nonAssignedEmailOrg);
                    await revertNonAssignableEmailLog(state.objectId)

                    const selectedIndex = email.data.findIndex((value: any, index: number) => value.objectId === state.objectId);
                    email.data[selectedIndex] = result.data;
                    updateEmailData({...email})
                }
            }
            
            setCurrentAssignedProperty(null);
            setLoading(false);
            setView('list');
        }
        catch(error){
            setLoading(false)
            setShowApiErrorModal(true)
        }
    }

    return(
        <>
            <TryagainModal
                open={showApiErrorModal}
                errorMessage="Save failed. Please try again."
                onClose={()=>setShowApiErrorModal(false)}
                onTryAgain={onSaveClick}
        />
        <Modal open={open} onClose={handleClose}>
			<Container
				style={{
                    background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
                >
				<div className="modal-wrapper-doc">
					<Stack 
						style={{ 
                            alignItems: "center",
							padding: '12px 24px',
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<SaveIcon 
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to save?</h2>
							<p style={{color: '#787878'}}>Save changes will charge the client, Do you want to proceed?</p>
						</div>
					</Stack>
					
					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
                        >
                        <Button onClick={() => handleClose()} variant="outlined">
                            No
                        </Button>
                        <Button onClick={onSaveClick} variant="contained">
                            Yes
                        </Button>
					</Stack>
				</div>
			</Container>
		</Modal>
                        </>
    )
}